import React, { useEffect, useState } from 'react';
import { Form, FloatingLabel, Button } from 'react-bootstrap';
import { BsTrash } from 'react-icons/bs';

interface TicketPriceFormProps {
    ticket_group_code: string;
    ticket_notes: string;
    tier: string[];
    currency: string;
    amount: string[];
    tier_id: string[];
    onTicketGroupCodeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    onTicketNotesChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onTierChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
    onCurrencyChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onAmountChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
    onAddMore: () => void;
    onDelete: (index: number) => void;
}

export default function TicketGroupCode({ticket_group_code, ticket_notes, tier, currency, amount, tier_id, onTicketGroupCodeChange, onTicketNotesChange, onTierChange, onCurrencyChange, onAmountChange, onAddMore, onDelete} : TicketPriceFormProps) {
    return (
        <>
            <Form.Group className="mb-3">
                <Form.Label className="text-sm mb-2">Tiers and Amounts</Form.Label>
                {tier.map((row, index) => (
                    <div key={index} className="d-flex align-items-center mb-3">
                        <Form.Control
                            type="text"
                            placeholder="Tier ID"  
                            value={tier_id[index]}  
                            readOnly
                            className="bg-gray-200 me-2"
                        />
                        <Form.Control
                            type="text"
                            placeholder="Tier"
                            value={tier[index]}
                            onChange={(e) => onTierChange(e as React.ChangeEvent<HTMLInputElement>, index)}
                            className="bg-gray-200 me-2"
                        />
                        <Form.Control
                            type="text"
                            placeholder="Amount"
                            value={amount[index]}
                            onChange={(e) => onAmountChange(e as React.ChangeEvent<HTMLInputElement>, index)}
                            className="bg-gray-200 me-2"
                        />
                        <Button variant="secondary" onClick={() => onDelete(index)}>
                            <BsTrash />
                        </Button>
                    </div>
                ))}
                <div>
                    <Button variant="danger" onClick={onAddMore}>
                        Add More
                    </Button>
                </div>
            </Form.Group>
        </>
    );
}
